<template>
  <div class="columns mgt-20px is-multiline">

    <div class="column is-12">
      <div class="card">
        <header class="header-card">
          <p>
            {{$t('societes.tab.journaux')}}
          </p>
        </header>
        <div class="card-content">
          <div class="columns is-multiline">
            <div class="column is-4">
              <b-field :label="$t('societes.journalAchat')">
                <b-input v-model="societe.journalAchat"></b-input>
              </b-field>
            </div>
            <div class="column is-4">
              <b-field :label="$t('societes.journalVente')">
                <b-input v-model="societe.journalVente"></b-input>
              </b-field>
            </div>
            <div class="column is-4">
              <b-field :label="$t('societes.journalOd')">
                <b-input v-model="societe.journalOd"></b-input>
              </b-field>
            </div>
          </div>
        </div>
      </div>
      <div class="card mgt-20px">
        <header class="header-card">
          <p>
            {{$t('societes.tab.centralisation')}}
          </p>
        </header>
        <div class="card-content">
          <div class="columns is-multiline">
            <div class="column is-4">
              <b-field :label="$t('societes.compteCentralisationFournisseur')">
                <b-input v-model="societe.compteCentralisationFournisseur"></b-input>
              </b-field>
            </div>
            <div class="column is-4">
              <b-field :label="$t('societes.compteCentralisationClient')">
                <b-input v-model="societe.compteCentralisationClient"></b-input>
              </b-field>
            </div>
          </div>
        </div>
      </div>
      <div class="card mgt-20px">
        <header class="header-card">
          <p>
            {{$t('societes.tab.gestionCourante')}}
          </p>
        </header>
        <div class="card-content">
          <div class="columns is-multiline">
            <div class="column is-4">
              <b-field :label="$t('societes.compteChargeGestionCourante')">
                <b-input v-model="societe.compteChargeGestionCourante"></b-input>
              </b-field>
            </div>
            <div class="column is-4">
            <b-field :label="$t('societes.compteProduitGestionCourante')">
                <b-input v-model="societe.compteProduitGestionCourante"></b-input>
              </b-field>
            </div>
          </div>
        </div>
      </div>
      <div class="card mgt-20px">
        <header class="header-card">
          <p>
            {{$t('societes.tab.acomptes')}}
          </p>
        </header>
        <div class="card-content">
          <div class="columns is-multiline" v-if="societe.id">
            <div class="column is-6">
              <schema-comptable :objetAvecSchemaComptable="societe"
                            label="societes.schemaComptableFacturation"
                            propertyForId="schemaComptableIdAcompteFacturation"
                            propertyForObject="schemaComptableFacturation">
              </schema-comptable>
            </div>
            <div class="column is-6">
              <schema-comptable :objetAvecSchemaComptable="societe"
                            label="societes.schemaComptableExtourne"
                            propertyForId="schemaComptableIdAcompteExtourne"
                            propertyForObject="schemaComptableExtourne">
              </schema-comptable>
            </div>
          </div>
        </div>
      </div>
      <div class="card mgt-20px">
        <header class="header-card">
          <p>
            {{$t('societes.tab.export')}}
          </p>
        </header>
        <div class="card-content">
          <div class="columns is-multiline">
            <div class="column is-4">
              <b-field :label="$t('societes.nomFichierExportLot')">
                <b-input v-model="societe.nomFichierExportLot"></b-input>
              </b-field>
            </div>
            <div class="column is-4">
              <b-field :label="$t('societes.tokenExtCompta')">
                <b-input v-model="societe.tokenExtCompta"></b-input>
              </b-field>
            </div>
            <div class="column is-4">
              <b-field :label="$t('societes.exportOdComptabiliteDefaut')">
                <qd-switch v-model="societe.exportOdComptabiliteDefaut"></qd-switch>
              </b-field>
            </div>
            <div class="column is-4">
              <b-field :label="$t('societes.exportComptaSpe')">
                <qd-switch v-model="societe.exportComptaSpe"></qd-switch>
              </b-field>
            </div>
            <div class="column is-4" v-if="societe.exportComptaSpe">
              <b-field class="obligatoire" :label="$t('societes.nomFichierExportSpe')">
                <b-input v-model="societe.nomFichierExportSpe"></b-input>
              </b-field>
            </div>
          </div>
        </div>
      </div>
      <div class="card mgt-20px">
        <header class="header-card">
          <p>
            {{$t('societes.tab.divers')}}
          </p>
        </header>
        <div class="card-content">
          <div class="columns is-multiline">
            <div class="column is-3">
              <b-field :label="$t('societes.destinataireComptable.destinataireComptable')">
                <b-select v-model="societe.choixDestinataireComptable" expanded>
                  <option v-for="destinataire in constantes.LISTE_DESTINATAIRE_COMPTABLE"
                          :key="destinataire.code"
                          :value="destinataire.code">
                    {{ $t(destinataire.libelle) }}
                  </option>
                </b-select>
              </b-field>
            </div>
            <div class="column is-3">
              <b-field :label="$t('societes.refSocInter')">
                <b-input v-model="societe.refSocInter"></b-input>
              </b-field>
            </div>
            <div class="column is-3">
              <b-field :label="$t('societes.masqueBloc.nomComptable')">
                <b-input v-model="societe.nomComptable"></b-input>
              </b-field>
            </div>
            <div class="column is-3">
              <b-field :label="$t('societes.tvaSurDebit')">
                <qd-switch v-model="societe.tvaSurDebit"></qd-switch>
              </b-field>
            </div>
          </div>
        </div>
      </div>
    </div>
    <gestion-masques-comptabilite :societe="societe">
    </gestion-masques-comptabilite>
    <b-modal v-model="showEdit" has-modal-card class="modal">
      <EditLibelle :value="societe.libelleEcritureAcompte"
                   type="ecritureAcompte"
                   @close="showEdit = false"
                   @save="societe.libelleEcritureAcompte = $event.value"/>
    </b-modal>
  </div>
</template>

<script>

import EditLibelle from '@/components/parametrage/schemaComptable/p_editLibelleEcriture';
import schemaComptable from '@/components/general/schemaComptable';
import GestionMasquesComptabilite
  from '@/components/parametrage/societes/ajoutEditionSociete/masque/m_gestionMasquesComptabilite';
import { LISTE_DESTINATAIRE_COMPTABLE } from '@/configuration/societe/societe';

export default {
  props: {
    societe: Object,
  },
  components: {
    EditLibelle,
    schemaComptable,
    GestionMasquesComptabilite,
  },
  data() {
    return {
      showEdit: false,
      constantes: {
        LISTE_DESTINATAIRE_COMPTABLE,
      },
    };
  },
};
</script>
